import React, {useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Dialog, Flex, Image, Text, useSlotRecipe} from '@chakra-ui/react3'
import {FormattedMessage, useIntl} from 'react-intl'

import {CancelIcon} from '../../../../../leap/components/icons'
import certificatesRecipe from '../../certificates.recipe'
import useHideInitialScrollbar from '../../../../../hooks/use-hide-initial-scrollbar'

export const Certificates = ({certificates}) => {
    const [overlayData, setOverlayData] = useState(null)

    const {formatMessage} = useIntl()
    const recipe = useSlotRecipe({recipe: certificatesRecipe})
    const scrollbarRef = useHideInitialScrollbar()
    const styles = useMemo(() => recipe({}), [recipe])

    if (certificates.length === 0) {
        return null
    }

    return (
        <Flex ref={scrollbarRef} css={styles.container}>
            {certificates?.map((certificate) => (
                <Button
                    unstyled
                    css={styles.button}
                    onClick={() =>
                        setOverlayData({
                            id: certificate?.id,
                            name: certificate?.name,
                            image: certificate?.image,
                            description: certificate?.description
                        })
                    }
                    key={certificate?.id}
                    aria-label={certificate?.name}
                >
                    <Image
                        css={styles.buttonImage}
                        alt={certificate?.name}
                        src={certificate?.image}
                    />
                </Button>
            ))}
            <Dialog.Root
                placement="center"
                open={overlayData !== null}
                onOpenChange={({open}) => {
                    if (!open) setOverlayData(null)
                }}
            >
                <Dialog.Backdrop css={styles.backdrop}>
                    <Dialog.Positioner>
                        <Dialog.Content
                            css={styles.content}
                            aria-label={formatMessage({
                                id: 'product_view.header.awards_and_certificates',
                                defaultMessage: 'Warranty & Certificates'
                            })}
                        >
                            <Dialog.CloseTrigger asChild>
                                <Button
                                    unstyled
                                    css={styles.closeTrigger}
                                    aria-label={formatMessage({
                                        id: 'global.close',
                                        defaultMessage: 'Close'
                                    })}
                                >
                                    <CancelIcon />
                                </Button>
                            </Dialog.CloseTrigger>
                            <Dialog.Body css={styles.body}>
                                <Dialog.Title asChild>
                                    <Text as="h2" css={styles.title}>
                                        <FormattedMessage
                                            id="product_view.header.awards_and_certificates"
                                            defaultMessage="Warranty & Certificates"
                                        />
                                    </Text>
                                </Dialog.Title>
                                <Box css={styles.contentWrapper}>
                                    <Box css={styles.imageContainer}>
                                        <Image
                                            key={overlayData?.id}
                                            css={styles.image}
                                            alt={overlayData?.name}
                                            src={overlayData?.image}
                                        />
                                    </Box>
                                    <Text as="h3" css={styles.name}>
                                        {overlayData?.name}
                                    </Text>
                                    <Text css={styles.description}>{overlayData?.description}</Text>
                                </Box>
                            </Dialog.Body>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Backdrop>
            </Dialog.Root>
        </Flex>
    )
}

Certificates.propTypes = {
    certificates: PropTypes.array,
    maxItems: PropTypes.number
}

export default Certificates
